import { createSlice } from '@reduxjs/toolkit';

import {
  serviceGetInventory,
  servicePutInventory,
  serviceDeleteInventory,
  servicePostInventory,
} from 'utils';


const initialState = {
  data: null,
  isLoaded: {
    post: false,
    put: false,
    delete: false,
    get: false,
  },
  success: {
    post: false,
    put: false,
    delete: false,
    get: false,
  },
  error: {
    post: false,
    put: false,
    delete: false,
    get: false,
  },
}

const InventorySlice = createSlice({
  name: 'inventory',
  initialState,
  reducers: {
    dataRequest(state, action) {
      return { ...state, isLoaded: { ...state.isLoaded, [action.payload]: true } };
    },

    dataSuccess(state, action) {
      return {
        ...state,
        isLoaded: { ...state.isLoaded, [action.payload.fetchType]: false },
        success: { ...state.success, [action.payload.fetchType]: true },
        data: action.payload.data || null,
      };
    },

    dataFailure(state, action) {
      return {
        ...state,
        isLoaded: { ...state.isLoaded, [action.payload.fetchType]: false },
        error: { ...state.error, [action.payload.fetchType]: action.payload.data?.message },
      };
    },

    cleanUpInventory() {
      return initialState;
    },

    cleanUpMessageInventory(state) {
      return {
        ...state,
        data: null,
        isLoaded: initialState.isLoaded,
        success: initialState.success,
        error: initialState.error,
      };
    },

  }
});

const {
  dataRequest,
  dataSuccess,
  dataFailure,
  cleanUpInventory,
  cleanUpMessageInventory
} = InventorySlice.actions;


const fetchGetInventory = (query) => {
  return (dispatch) => {
    dispatch(dataRequest('get'));
    serviceGetInventory(query)
      .then((response) => dispatch(dataSuccess({data: response.data, fetchType: 'get'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'get'})));
  };
};

const fetchPostInventory = (body) => {
  return (dispatch) => {
    dispatch(dataRequest('post'));
    servicePostInventory(body)
      .then((response) => dispatch(dataSuccess({data: response.data, fetchType: 'post'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'post'})));
  };
};

const fetchPutInventory = (body) => {
  return (dispatch) => {
    dispatch(dataRequest('put'));
    servicePutInventory(body)
      .then((response) => dispatch(dataSuccess({data: response.data, fetchType: 'put'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'put'})));
  };
};

const fetchDeleteInventory = (body) => {
  return (dispatch) => {
    dispatch(dataRequest('delete'));
    serviceDeleteInventory(body)
      .then((response) => dispatch(dataSuccess({data: response.data, fetchType: 'delete'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'delete'})));
  };
};

export {
  fetchGetInventory,
  fetchPostInventory,
  fetchPutInventory,
  fetchDeleteInventory,
  cleanUpInventory,
  cleanUpMessageInventory
};

export default InventorySlice.reducer;
